import _hiTranslations from './hi.json';

const translation = {
  ..._hiTranslations,
};

export default translation;
